/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ErpProvisioningStatusResponse { 
    saasTransactionID: string;
    /**
     * Response status code (e.g., Pending, Success, Failed)
     */
    responseCode: string;
    /**
     * Optional message to provide context or error details
     */
    responseMsg?: string;
}

